/**
 * Centralized React Query key factory.
 * Add new domain keys here; never hand-roll keys at call sites.
 */
export const queryKeys = {
  auth: {
    me: () => ['auth', 'me'],
  },
  deployments: {
    all: () => ['deployments'],
    list: (filters) => ['deployments', 'list', filters],
    detail: (id) => ['deployments', 'detail', id],
  },
  users: {
    all: () => ['users'],
    list: (filters) => ['users', 'list', filters],
    detail: (id) => ['users', 'detail', id],
  },
  overviewConfig: {
    detail: (depId) => ['deployment', depId, 'overview-config'],
  },
  svgTemplates: {
    all: () => ['svg-templates'],
  },
  notifications: {
    all: (depId) => ['deployment', depId, 'notifications'],
    list: (depId, filters) => ['deployment', depId, 'notifications', 'list', filters],
  },
  notificationTemplates: {
    resolve: (event, channel) => ['notification-templates', event ?? 'any', channel ?? 'any'],
  },
  notificationEvents: {
    all: () => ['notification-events'],
  },
};
